import { put, takeLatest } from 'redux-saga/effects'

import { selectSuccess, selectFailure } from '../actions/locations'
import { api } from '../api'
import { SELECT_REQUEST } from '../types/locations'

function* select(action) {
  try {
    const response = yield api({
      method: 'GET',
      params: {},
      url: `/projects/${action.payload.data.project.id}/location-tags`,
    })
    yield put(selectSuccess(response.data))
  } catch (error) {
    yield put(selectFailure(error.response.data))
  }
}

function* locations() {
  yield takeLatest(SELECT_REQUEST, select)
}

export { locations }
